import { BrowserRouter, Route, Routes } from "react-router-dom";
// Components
import Loading from "./components/Loading";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";
// Pages
import About from "./pages/about/About";
import Contact from "./pages/contact/Conatct";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import NotFound from "./pages/404/NotFound";
import EditProfile from "./pages/profile/EditProfile";
import Profile from "./pages/profile/Profile";
import CreateProject from "./pages/projects/CreateProject";
import EditProject from "./pages/projects/EditProject";
import ProjectDetails from "./pages/projects/ProjectDetails";
import Projects from "./pages/projects/Projects";
import ResetPassword from "./pages/reset-password/ResetPassword";
// Hooks
import { useAuthContext } from "./hooks/useAuthContext";
// Styles
import "./styles/App.css";
// Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
  const { authIsReady } = useAuthContext();

  // Application routes
  const routes = [
    // General pages
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/contact", element: <Contact /> },
    // Projects
    { path: "/projects", element: <Projects /> },
    { path: "/projects/:id", element: <ProjectDetails /> },
    { path: "/projects/:id/edit", element: <EditProject />, private: true },
    { path: "/create-project", element: <CreateProject />, private: true },
    // Profiles
    { path: "/profile/:name", element: <Profile /> },
    { path: "/edit-profile", element: <EditProfile />, private: true },
    // Authentication
    { path: "/login", element: <Login /> },
    { path: "/forgot-password", element: <ForgotPassword /> },
    { path: "/reset-password", element: <ResetPassword /> },
    // 404
    { path: "*", element: <NotFound /> },
  ];

  return (
    <BrowserRouter>
      {/* Main application wrapper */}
      <div className="App">
        {/* Scroll to the top when navigating between pages */}
        <ScrollToTop />
        {/* Wait until Firebase authentication is ready */}
        {!authIsReady ? (
          <Loading />
        ) : (
          <>
            {/* Global navigation */}
            <Navbar />
            {/* Application routes */}
            <Routes>
              {routes.map(({ path, element, private: isPrivate }) => (
                <Route
                  key={path}
                  path={path}
                  element={isPrivate ? <PrivateRoute>{element}</PrivateRoute> : element}
                />
              ))}
            </Routes>
          </>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
